module.exports = __webpack_public_path__ + "media/images/emblems/Varen-coat_of_arms-685330b59e170c36030cf523191b1cd6.svg";